module.exports = __webpack_public_path__ + "img/dashboard_my_watches.49912dbd.svg";